import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const ClientChangedPersonalDataDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => {
  const changedFieldNames = data.changedFieldNames.join(', ');
  const teamManager = data.managerId ? (
    <DetailsRow
      label="Manager ID"
      value={`${data.managerId}, ${data.managerName}`}
    />
  ) : null;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
      <DetailsRow label="Name" value={data.leadFullName} />
      <DetailsRow label="Changed Personal Data" value={changedFieldNames} />
      {teamManager}
    </>
  );
};
